import type { PresentationItem } from '@/types/presentation';

export function ctxStr(item: PresentationItem, key: string): string {
  const val = item.context_data?.[key];
  return typeof val === 'string' ? val : '';
}

export function fmtDate(raw: string): string {
  if (!raw) return '';
  try {
    return new Date(raw).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return raw;
  }
}

export function fmtTime(raw: string): string {
  if (!raw) return '';
  try {
    const [h, m] = raw.split(':');
    const d = new Date();
    d.setHours(Number(h), Number(m));
    return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  } catch {
    return raw;
  }
}

export function getSlideCount(item: PresentationItem): number {
  if (!item.pptx_code) return 0;
  try {
    const deck = JSON.parse(item.pptx_code) as { slides?: unknown[] };
    return Array.isArray(deck.slides) ? deck.slides.length : 0;
  } catch {
    return 0;
  }
}
